/**
 * Inspects an object and extracts properties
 * that are relevant to the web_ide_link.vue
 * component.
 *
 * @returns An object with properties that are
 * relevant to the web_ide_link.vue component. See EE version.
 */
export const provideWebIdeLink = () => ({});
